import { SiteState } from '..';
import { Storyblok } from '../../storyblok';

export type SiteActions =
    | {
          payload: Storyblok.Content.ErrorType;
          type: 'SET_ERROR';
      }
    | {
          type: 'CLEAR_ERROR';
      }
    | {
          payload: any;
          type: 'ADD_DATASOURCES';
      }
    | {
          payload: SiteState['pageguards'];
          type: 'UPDATE_PAGEGUARDS';
      };

export const setError = (
    payload: Storyblok.Content.ErrorType,
): SiteActions => ({
    payload,
    type: 'SET_ERROR',
});

export const clearError = (): SiteActions => ({ type: 'CLEAR_ERROR' });

export const addDatasources = (payload: any): SiteActions => ({
    type: 'ADD_DATASOURCES',
    payload,
});

export const updatePageGuards = (
    payload: SiteState['pageguards'],
): SiteActions => ({
    type: 'UPDATE_PAGEGUARDS',
    payload,
});
